export default {
  nav: {
    home: 'Avaleht',
    about: 'Meist',
    services: 'Teenused',
    projects: 'Projektid',
    blog: 'Blogi',
    contact: 'Kontakt'
  },
  hero: {
    title: 'Eesti Hariduse Instituut',
    subtitle: 'Toetame haridusasutusi professionaalse arengu ja innovatsiooni teel',
    cta: 'Tutvu Meiega'
  },
  about: {
    title: 'Meist',
    description: 'Eesti Hariduse Instituut on juhtiv haridusasutuste arendamise ja koolituste pakkuja Eestis. Meie missioon on toetada õpetajaid ja haridusasutusi kvaliteetse hariduse pakkumisel läbi innovaatiliste lahenduste ja professionaalse toe.',
    hero: {
      badge: 'Meist',
      title: 'Eesti Hariduse Instituut',
      subtitle: 'Oleme juhtiv haridusasutuste arendamise ja koolituste pakkuja Eestis, toetades õpetajaid ja haridusasutusi kvaliteetse hariduse pakkumisel.',
      description: 'Oleme juhtiv haridusasutuste arendamise ja koolituste pakkuja Eestis. Meie missioon on toetada õpetajaid ja haridusasutusi kvaliteetse hariduse pakkumisel läbi innovaatiliste lahenduste ja professionaalse toe.'
    },
    stats: {
      years: 'Aastat kogemust',
      projects: 'Läbiviidud projekti',
      partners: 'Koostööpartnerit',
      trained: 'Koolitatud õpetajat'
    },
    mission: {
      title: 'Meie Missioon',
      subtitle: 'Usume, et iga õpetaja ja haridusasutus väärib parimat tuge oma arenguteel',
      description: 'Eesti Hariduse Instituudi missioon on tõsta Eesti hariduse kvaliteeti läbi professionaalse täiendusõppe, teaduspõhise nõustamise ja rahvusvaheliste koostöövõrgustike. Töötame iga päev selle nimel, et haridusasutustel oleks ligipääs kõrgeima taseme teadmistele, meetoditele ja kogemustele.',
      vision: 'Meie visioon on Eesti, kus iga õpilane saab inspireerivat ning kaasaegset haridust — ja selle võimalikuks teeb hästi toetatud ja motiveeritud õpetajaskond.',
      pillars: {
        title: 'Missioonisambad',
        quality: {
          title: 'Kvaliteet kõiges',
          description: 'Iga koolitus, nõustamine ja projekt läbib range kvaliteedikontrolli. Töötame ainult tõenduspõhiste meetoditega, mis on end rahvusvaheliselt tõestanud.'
        },
        teacher: {
          title: 'Õpetaja keskel',
          description: 'Õpetaja on haridusmuutuse võtmeisik. Toetame õpetajate professionaalset arengut, enesekindlust ja motivatsiooni, sest nende heaolu mõjutab otseselt iga õpilast.'
        },
        future: {
          title: 'Tulevikuvaade',
          description: 'Haridus peab valmistama ette homseks maailmaks. Toome kooli 21. sajandi pädevused — kriitiline mõtlemine, digipädevus, koostöö ja loovus.'
        },
        community: {
          title: 'Tugev kogukond',
          description: 'Loome võrgustikke, kus haridusasutused saavad jagada kogemusi, lahendada probleeme koos ja õppida üksteiselt. Üksi ollakse väike, koos ollakse tugev.'
        }
      },
      commitment: 'Meie lubadus on olla usaldusväärne partner igale haridusasutusele — alates esimesest kohtumisest kuni pikaajalise koostööni.'
    },
    story: {
      title: 'Meie Lugu',
      description1: 'Eesti Hariduse Instituut asutati eesmärgiga pakkuda kvaliteetset täienduskoolitust ja tuge haridusasutustele üle Eesti.',
      description2: 'Meie meeskond koosneb kogenud haridustöötajatest, akadeemilistest ekspertidest ja praktikutest.',
      description3: 'Täna teenindame üle 50 haridusasutuse ja oleme koolitanud tuhandeid õpetajaid üle Eesti.',
      beginning: {
        title: 'Algus',
        description: 'Asutasime instituudi 2009. aastal, nähes vajadust süsteemsema toe järele Eesti haridusasutustele. Esimesed koolitused toimusid 12 osalejaga — täna ulatub meie haare tuhandete õpetajateni.'
      },
      growth: {
        title: 'Kasv ja areng',
        description: 'Aastatega laiendasime tegevust nõustamisele, rahvusvahelistele projektidele ja digipädevuse valdkonda. Täna töötame koostöös ülikoolide, ministeeriumite ja Euroopa partneritega.'
      },
      future: {
        title: 'Tulevik',
        description: 'Vaatame tulevikku optimismiga. Arendame uusi programme, digitaalseid lahendusi ja rahvusvahelisi koostöövõrgustikke, et Eesti haridus jääks maailma eesrindesse.'
      }
    },
    values: {
      title: 'Meie Väärtused',
      innovation: {
        title: 'Innovatsioon',
        description: 'Toome haridusesse uudseid lähenemisi ja kaasaegseid õppemeetodeid, mis toetavad õpilaste arengut tuleviku maailmas.'
      },
      collaboration: {
        title: 'Koostöö',
        description: 'Loome tugevaid võrgustikke haridusasutuste vahel ja toetame kogemuste jagamist üle Eesti ning rahvusvaheliselt.'
      },
      excellence: {
        title: 'Tipptase',
        description: 'Pakume kõrgeima kvaliteediga koolitusi ja nõustamist, mis vastavad kaasaegsetele rahvusvahelistele standarditele.'
      }
    },
    team: {
      title: 'Meie Meeskond',
      subtitle: 'Kogenud eksperdid, kes hoolivad haridusest südamest'
    },
    testimonial: {
      quote: 'Eesti Hariduse Instituudi tugi on olnud meie koolile hindamatu. Tänu nende koolitustele ja nõustamisele oleme suutnud oluliselt tõsta õpetajate motivatsiooni ja õpitulemusi.',
      author: 'Tiina Rebane',
      position: 'Direktor, Tallinna Ühisgümnaasium'
    },
    partners: {
      title: 'Meie Partnerid',
      description: 'Teeme koostööd juhtivate haridusasutuste, ülikoolide ja organisatsioonidega nii Eestis kui välismaal, et pakkuda parimat võimalikku tuge hariduse arendamisel.'
    }
  },
  services: {
    title: 'Meie Teenused',
    subtitle: 'Pakume laia valikut haridusalaseid teenuseid',
    training: {
      title: 'Koolitused',
      description: 'Professionaalsed täienduskoolitused õpetajatele ja haridusasutustele'
    },
    consulting: {
      title: 'Nõustamine',
      description: 'Ekspertide nõustamine haridusasutuste arendamisel'
    },
    projects: {
      title: 'Projektid',
      description: 'Rahvusvahelised haridusprojektid ja koostöövõrgustikud'
    },
    digital: {
      title: 'Digipädevus',
      description: 'Kaasaegsed lahendused digitaalse õppimise toetamiseks'
    }
  },
  footer: {
    description: 'Toetame haridusasutusi professionaalse arengu ja innovatsiooni teel.',
    quickLinks: 'Kiirlingid',
    contact: 'Kontakt',
    newsletter: 'Uudiskiri',
    newsletterText: 'Liitu meie uudiskirjaga ja saa värskeid uudiseid haridusmaailmast.',
    subscribe: 'Liitu',
    emailPlaceholder: 'Sinu e-posti aadress',
    rights: 'Kõik õigused kaitstud.'
  }
};